import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type SuspendReason =
  | "USER_ABORTED" // User aborted (0)
  | "ALARM" // Terminated by alarm (1)
  | "MALFUNCTION" // Terminated due to malfunction (2)
  | "PLGS"; // Auto suspend by Predictive Low Glucose Suspend (6)

export type PumpingSuspendedPayload = {
  insulin_amount?: number;
  reason?: number;
};

export type PumpingSuspendedEvent = {
  insulinAmount?: number;
  suspend: "auto" | "manual";
  reason?: SuspendReason;
};

const pumpingSuspendedSchema = z.object({
  insulin_amount: cz.permissive(z.number()),
  reason: cz.permissive(z.number()),
});

export const LID_PUMPING_SUSPENDED = {
  value: 0x0b,
  name: "Pumping Suspended Event",
  format: "....hb.........",
  fields: ["insulin_amount", "reason"],
  postprocess: rec => ({
    insulinAmount: rec.insulin_amount,
    reason: getReason(rec.reason),
    suspend: rec.reason === 0 ? "manual" : "auto",
  }),
  schema: pumpingSuspendedSchema,
} as const satisfies TandemEventDefinition<PumpingSuspendedPayload, PumpingSuspendedEvent>;

const getReason = (reason: number | undefined): SuspendReason | undefined => {
  switch (reason) {
    case undefined:
      return undefined;
    case 0:
      return "USER_ABORTED";
    case 1:
      return "ALARM";
    case 2:
      return "MALFUNCTION";
    case 6:
      return "PLGS";
  }
  return undefined;
};
